import {PASearch} from "../PA.Core/PASearch";
import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Tag_Rule_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_TAG_RULE_ID: {
        type: SearchProviderFieldType.number,
        domainOptions: {},
        renderOptions: {
            columnName: 'Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Center
        }
    },
    TAG_RULE_ID: {
        type: SearchProviderFieldType.string,
        domainOptions: {},
        renderOptions: {
            columnName: 'Tag Rule Id',
            columnResourceName: 'colIdx',
            alignment: HorizAlignment.Left
        }
    },
    TAG_RULE_NAME: {
        type: SearchProviderFieldType.string,
        domainOptions: {
            maxLength: 100
        },
        renderOptions: {
            columnName: 'Tag Rule Name',
            columnResourceName: 'colName',
            alignment: HorizAlignment.Left
        }
    },
    WB_TAG_ID: {
        type: SearchProviderFieldType.number,
        domainOptions: {
            maxLength: 50
        },
        renderOptions: {
            columnName: 'Tag Id',
            columnResourceName: 'colTagId',
            alignment: HorizAlignment.Left
        }
    },
    WB_TAG_FUNCTION_ID: {
        type: SearchProviderFieldType.number,
        domainOptions: {
            maxLength: 50
        },
        renderOptions: {
            columnName: 'Tag Function Id',
            columnResourceName: 'colTagFunctionId',
            alignment: HorizAlignment.Left
        }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created DtTs', columnResourceName: 'colCreatedDtTs', alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified DtTs', columnResourceName: 'colModifiedDtTs', alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    DELETED_IND: {
        type: SearchProviderFieldType.string,
        domainOptions: {},
        renderOptions: {
            columnName: 'Deleted Ind',
            columnResourceName: 'colDeletedInd',
            alignment: HorizAlignment.Left
        }
    },
    DELETED_DT: {
        type: SearchProviderFieldType.sapdate,
        domainOptions: {
            maxLength: 50
        },
        renderOptions: {
            columnName: 'Deleted Date',
            columnResourceName: 'colDeleted_Date',
            alignment: HorizAlignment.Center
        }
    }
};

const TagRuleSearchProviderBasic: ISearchProvider = {
    keyFields: {
        id: 'WB_TAG_RULE_ID',
        id_ui: 'TAG_RULE_ID',
        name: 'TAG_RULE_NAME'
    },

    searchProviderFields: vUI_Tag_Rule_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            const findRequest = SearchUtils.makeSearchRequest(
                searchOptions,
                'vUI_Tag_Rule_Search',
                this.searchProviderFields,
                [])
            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
};

const TagRuleSearchProfileByName: ISearchProfile = {
    profileId: 'default',
    profileName: 'Search by Id, Name',
    renderOptions: {
        ui5ResourceId: 'TagRuleSearchProfileByName'
    },

    profileFilter: [
        { profileFilterName: 'Id',   searchProviderFieldId: 'TAG_RULE_ID',   renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'TAG_RULE_NAME', renderOptions: {} }
    ],
    profileDisplayFields: [
        'TAG_RULE_ID', 'TAG_RULE_NAME', 'WB_TAG_ID', 'WB_TAG_FUNCTION_ID',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: TagRuleSearchProviderBasic,

    profileSortIdDefault: '',
    profileSorts: [],
};

const TagRuleSearch: ISearch = {
    searchName: 'Find Tag Rule',
    renderOptions: {
        ui5ResourceId: 'TagRuleSearch'
    },

    searchProfileIdDefault: 'default',
    searchProfiles: [TagRuleSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("TagRuleBO", "TagRule", TagRuleSearch, "Tag Rule Search")

export { TagRuleSearch }
